import type { Logger } from '@wix/wix-data-client-common-standalone'
import {
  findError,
  isMissingPermissionsError,
} from '@wix/wix-data-client-common-standalone'
import type { HttpClient } from '@wix/http-client'
import { CMS } from '@wix/app-definition-ids'
import {
  getInstalledApps,
  installApp,
} from '@wix/ambassador-apps-v1-app-instance/http'
import { V1TenantType } from '@wix/ambassador-apps-v1-app-instance/types'

const shouldInstallCMSAutomationsApp = async ({
  logger,
  httpClient,
}: {
  logger: Logger
  httpClient: HttpClient
}): Promise<boolean> => {
  try {
    const {
      data: { appInstances = [] },
    } = await httpClient.request(getInstalledApps({}))
    const alreadyInstalled = appInstances.some(app => app.appDefId === CMS)
    return !alreadyInstalled
  } catch (error) {
    if (findError(error, isMissingPermissionsError)) {
      return false
    }

    logger.error(
      new Error('Failed to check if CMS Automations app is installed', {
        cause: error,
      }),
    )
    return true
  }
}

export const installCMSAutomationsApp = async ({
  logger,
  httpClient,
  metaSiteId,
}: {
  logger: Logger
  httpClient: HttpClient
  metaSiteId: string
}): Promise<void> => {
  const shouldInstall = await shouldInstallCMSAutomationsApp({
    logger,
    httpClient,
  })

  if (!shouldInstall) {
    return
  }

  try {
    await httpClient.request(
      installApp({
        tenant: {
          id: metaSiteId,
          tenantType: V1TenantType.SITE,
        },
        appInstance: { appDefId: CMS },
      }),
    )
  } catch (error) {
    if (findError(error, isMissingPermissionsError)) {
      return
    }
    logger.error(
      new Error('Failed to install CMS Automations app', {
        cause: error,
      }),
    )
  }
}
